export default function createReducer(initialState, handlers) {
  if (process.env.NODE_ENV !== 'production' && handlers['undefined']) {
    console.warn(
      "Reducer contains an 'undefined' action type. " +
        'Have you misspelled a constant?'
    );
  }

  return (state, action) => {
    if (state === undefined) state = initialState;

    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action.payload);
    } else {
      return state;
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/common/redux/utils/createReducer.js